"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var dictionary_1 = __importDefault(require("../../../dictionary"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var selectors_1 = require("../../common/selectors");
var selectors_2 = require("../selectors");
var NoFindProducts = function () {
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_1.isCustomStoreSelector);
    var filters = (0, selectors_2.useFiltersSelector)(isCustomStore);
    return (react_1.default.createElement("div", { className: "no-find-products" },
        react_1.default.createElement("h3", null,
            dictionary_1.default.store.Didnt_find_what_you_were_looking_for,
            "?"),
        react_1.default.createElement("a", { href: filters.cod, onClick: function () {
                return (0, track_event_1.default)({
                    category: 'store button',
                    action: 'no_products_create_design',
                });
            }, className: "b-btn b-btn_info" }, dictionary_1.default.store.Create_own_design)));
};
exports.default = NoFindProducts;
